﻿import { defineComponent } from 'vue';

import trip_summary from "../common/trip_summary.vue"
import trip_summary_discount from "../common/trip_summary_discount.vue"
import itinerary_breakdown from "../common/itinerary_breakdown.vue";

import { Booking } from "../../../services/booking";
import { Payment } from "../../../services/payment";

import { Currency_Service } from "../../../../system/services/currency";

const Book: Booking = new Booking();
const Pay: Payment = new Payment();
const Currency_Services: Currency_Service = new Currency_Service();

import { response } from "../../../objects/v1_3/payment/initialise/response";
import { response_method } from "../../../objects/v1_3/payment/initialise/response_method";

import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group";
import { request_payment_initialise_internal } from "../../../objects/v1_3/payment/initialise/request_payment_initialise_internal";

export default defineComponent({
    name: "checkout_trip_summary",
    components: {
        trip_summary,
        trip_summary_discount,
        itinerary_breakdown
    },
    props: {
    },
    emits: [
        "passengerCheck"
    ],
    data() {
        return {
            checkout: "Check out now",
            full_payment: true,
            deposit: false,
            agreeCheckbox: false as Boolean,
            displayCompleteRequired: false as Boolean,
            failingPassengerIndex: -1 as number,
            isloading: false as Boolean,
        }
    },
    methods: {
        async check_out() {
            this.$store.commit("Set_isValidPassengers", { isValidPassengers: null });
            this.$emit("passengerCheck", true);
            this.isloading = true;

            // Wait for passenger validation instead of 2 second timer
            await new Promise<void>((resolve) => {
                const unwatch = this.$watch(
                    () => this.$store.getters.get_isValidPassengers,
                    (val) => {
                        if (val !== null) {
                            unwatch();
                            resolve();
                        }
                    }
                );
                // Safety timeout fallback - 10s should cover even very slow connections
                setTimeout(() => { unwatch(); resolve(); }, 10000);
            });

            if ((Book.Valid_Overall_Passenger(this.$store.getters.get_Booking) == true && this.$store.getters.get_isValidPassengers == true) || this.isPaymentLink()) {
                this.$store.commit("Set_Payment_Full_Payment", { Payment: this.full_payment });
                this.$store.commit("Set_Payment_Deposit", { Payment: this.deposit });
                this.$router.push({ path: "/creditcard" });
            } else {
                this.failingPassengerIndex = Book.Index_Of_First_Failing_Passenger(this.$store.getters.get_Booking) ?? 0;
                this.$emit("passengerCheck", false);
                this.displayCompleteRequired = true;
            }
            this.isloading = false;
        },
        enableContinueButton() {
            if(this.agreeCheckbox == true) {
                if(this.$store.getters.get_isValidPassengers == true || this.isPaymentLink()){
                    this.displayCompleteRequired = false;
                    return true;
                }
                else
                {
                    this.displayCompleteRequired = true;
                }
            }

            return false;

        },
        No_Deposit(): boolean {
            var total_outstanding = Book.get_total_outstanding(this.$store.getters.get_Booking);
            var total_deposit = Book.get_Total_Deposit(this.$store.getters.get_Booking);

            if (this.has_Payment_Session()) {
                total_outstanding = Pay.get_total_outstanding(this.$store.getters.get_Payment_Session);
                total_deposit = Pay.get_Total_Deposit(this.$store.getters.get_Payment_Session);
                
                let payment_session : request_payment_initialise_internal = this.$store.getters.get_Payment_Session

                if (payment_session?.payment_initialise?.deposit == true) {
                    this.deposit_selected();
                }
            }

            return total_outstanding == total_deposit;
        },
        has_Payment_Session() : boolean {
            let Payment_Session = this.$store.getters.get_Payment_Session;
            if (!(Payment_Session == undefined || Payment_Session == null || Payment_Session.payment_session == null)) {
                return true;
            }
            return false;
        },
        get_total_outstanding_Formatted(): string {
            var total_outstanding = 0;

            if (this.has_Payment_Session()) {
                total_outstanding = Pay.get_total_outstanding(this.$store.getters.get_Payment_Session);
            } else {
                total_outstanding = Book.get_total_outstanding(this.$store.getters.get_Booking);
            }

            return Currency_Services.Format_Currency(total_outstanding, this.$store.getters.get_Currency);
        },
        get_Total_Deposit_Formatted(): string {
            var total_deposit = 0;

            if (this.has_Payment_Session()) {
                total_deposit = Pay.get_Total_Deposit(this.$store.getters.get_Payment_Session);
            } else {
                total_deposit = Book.get_Total_Deposit(this.$store.getters.get_Booking);
            }

            return Currency_Services.Format_Currency(total_deposit, this.$store.getters.get_Currency);
        },
        get_Total_Selected_Formatted(): string {
            if (this.full_payment == true) {
                return this.get_total_outstanding_Formatted();
            }

            if (this.deposit == true) {
                return this.get_Total_Deposit_Formatted();
            }

            return "";
        },
        get_Balance(): string {
            return Currency_Services.Format_Currency(Book.get_Balance(this.$store.getters.get_Booking), this.$store.getters.get_Currency);
        },
        full_payment_selected() {
            this.full_payment = true;
            this.deposit = false;
        },
        deposit_selected() {
            this.full_payment = false;
            this.deposit = true;
        },
        get_Currency(): string {
            return this.$store.getters.get_Currency?.currency_info?.iso_currency_code;
        },
        terms_policy(): string {
            return String(import.meta.env.VITE_FOOTER_POLICY_TERMS);
        },
        get_Contact_Text(): string {
            return String(import.meta.env.VITE_DEFAULT_CONTACT_TEXT);
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        isPaymentLink(): boolean {
            return window.location.href.toLowerCase().includes('paylink');
        }
    },
    mounted() {
        if (this.$store.getters.get_Agent_Login?.valid_login == true) {
            this.agreeCheckbox = true;
        }


    }
})